/* eslint-disable import/prefer-default-export */
import { IntlShape } from "react-intl";

export function getBadgeTranslations(label: string, intl: IntlShape) {
  if (!label) return "";
  switch (label.toLowerCase()) {
    case "active":
      return intl.formatMessage({
        id: "general.active",
        defaultMessage: "Active",
      });

    // Quote requests
    case "quoted":
      return intl.formatMessage({
        id: "general.quoted",
        defaultMessage: "Quoted",
      });
    case "open for quotations":
      return intl.formatMessage({
        id: "quote.listing.openForQuotations",
        defaultMessage: "Open for quotations",
      });
    case "closed for quotations":
      return intl.formatMessage({
        id: "quote.listing.closedForQuotation",
        defaultMessage: "Closed for quotations",
      });
    case "lost":
      return intl.formatMessage({
        id: "general.lost",
        defaultMessage: "Lost",
      });
    case "expired":
      return intl.formatMessage({
        id: "general.expired",
        defaultMessage: "Expired",
      });
    case "closed":
      return intl.formatMessage({
        id: "general.closed",
        defaultMessage: "Closed",
      });

    // Shipments
    case "booked":
      return intl.formatMessage({
        id: "general.booked",
        defaultMessage: "Booked",
      });
    case "in transit":
      return intl.formatMessage({
        id: "general.inTransit",
        defaultMessage: "In Transit",
      });
    case "delivered":
      return intl.formatMessage({
        id: "general.delivered",
        defaultMessage: "Delivered",
      });
    case "delayed":
      return intl.formatMessage({
        id: "general.delayed",
        defaultMessage: "Delayed",
      });
    case "incomplete":
      return intl.formatMessage({
        id: "general.incomplete",
        defaultMessage: "Incomplete",
      });
    case "auto-closed":
      return intl.formatMessage({
        id: "components.molecules.navigation.autoClosed",
        defaultMessage: "Auto-Closed",
      });

    // Invoices
    case "approved":
      return intl.formatMessage({
        id: "general.approved",
        defaultMessage: "Approved",
      });
    case "pending":
      return intl.formatMessage({
        id: "general.pending",
        defaultMessage: "Pending",
      });
    case "awaiting audit":
      return intl.formatMessage({
        id: "billing.awaitingAudit",
        defaultMessage: "Awaiting Audit",
      });
    case "auto canceled":
      return intl.formatMessage({
        id: "general.autoCanceled",
        defaultMessage: "Auto-Canceled",
      });
    case "removed":
      return intl.formatMessage({
        id: "tabs.removed",
        defaultMessage: "Removed",
      });
    default:
      return label;
  }
}
